<template>
    <button
        class="dm-hidden-cypress-button-sample"
        style="display: none"
        @click="presentation.sample_uploaded = true"
    >
        Hidden Cypress Sample Button
    </button>

    <div class="mb-8">
        <VueDropzone
            class="dropzone dropzone-default dz-clickable dz-started mb-4"
            :accepted_file_types="['application/pdf']"
            :max_file_size="maxFileSize"
            :upload_url="uploadSampleUrl"
            @uploadSuccessful="replaceSampleProps"
            @uploadFailedDueToFileTypes="showFileTypesError"
            @uploadFailedDueToFileSize="showFileSizeError"
            @uploadFailed="showSwalErrorPopup"
        >
            <div class="dropzone-msg dz-message needsclick">
                <h3 class="dropzone-msg-title">
                    {{ translate("Upload sample chapters here") }}
                </h3>
                <span class="dropzone-msg-desc d-block">{{
                    translate("We only receive .pdf files")
                }}</span>
                <span class="dropzone-msg-desc d-block">{{
                    translate("Maximum file size is 75MB")
                }}</span>
                <span class="dropzone-msg-desc d-block">{{
                    translate(
                        "Large files take long to load, so keep size to a minimum",
                    )
                }}</span>
            </div>
        </VueDropzone>

        <div
            v-if="presentation.sample_uploaded"
            class="d-flex align-items-center dm-wizard-document-wrap"
        >
            <a
                class="btn btn-sm btn-light"
                target="_blank"
                :href="presentation.sample_url"
            >
                <i
                    class="las la-file-pdf ml-3 icon-xl"
                    v-if="presentation.sample_extension == 'pdf'"
                ></i>
                <i class="las la-file-alt ml-3 icon-xl" v-else></i>
                <span
                    >{{ translate("Previously uploaded sample") }}:
                    <em>{{ presentation.sample_file_name }}</em></span
                >
            </a>
            <button
                class="btn btn-xs btn-icon btn-light-danger ml-4 dm-small-close-button"
                @click="deleteSample()"
            >
                <i class="icon-xs las la-times"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";
import VueDropzone from "@/components/shared/VueDropzone.vue";

export default {
    components: { VueDropzone },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["presentation"]),

        maxFileSize() {
            return 75 * 1024 * 1024; // 75MB
        },

        uploadSampleUrl() {
            return (
                "/api/author/presentations/" +
                this.presentation.id +
                "/documents/sample"
            );
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["loadNavigation"]),

        replaceSampleProps(data) {
            this.presentation.sample_uploaded = data.sample_uploaded;
            this.presentation.sample_url = data.sample_url;
            this.presentation.sample_extension = data.sample_extension;
            this.presentation.sample_file_name = data.sample_file_name;

            this.loadNavigation();
            this.showSwalSuccessPopup();
        },

        showFileTypesError() {
            this.showSwalErrorPopup("Please select only PDF files!");
        },

        showFileSizeError() {
            this.showSwalErrorPopup("Maximum file size is 75MB!");
        },

        deleteSample() {
            var self = this;
            axios.delete(this.uploadSampleUrl).then(function (response) {
                self.replaceSampleProps(response.data);
            });
        },
    },
};
</script>
